import styled from 'styled-components';

import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';
import off from './images/check-off.svg'
import on from './images/check-on.svg'

export const Wrap = styled.div`

`;

export const TopWrap = styled.div`
  position: relative;

  > div.youtube {
    width: 77%;
    position: absolute;
    top: 42.5%;
    left: 50%;
    transform: translateX(-50%);

    > div {
      height: 0;
      padding-top: 56.25%;
      position: relative;
    }

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const Contents = styled.div`
  position: relative;  
  div.check {
    position: relative;
    display: inline-block;
  }

  img.submit {
    width: 40%;
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const Quiz1Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 85%;

  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);

  > div {
    text-align: center;
    width: 33%;
    > img {
      width: 90%;
    }

    img.checkImg {
      width: 20%;
      position: absolute;
      left: 20%;
      top: -20%;
      transform: translateX(-50%);
    }
  }
`;

export const Quiz2Wrap = styled.div`
  width: 80%;
  position: absolute;
  top: 62%;
  left: 50%;
  transform: translateX(-50%);

  img.checkImg {
    width: 8%;
    position: absolute;
    left: 4%;
    top: -20%;
    transform: translateX(-50%);
  }

  > textarea {
    margin-top: 2%;
    padding: 2%;
    width: 96%;
    height: 100%;
    background-color: #f5f4f6;
    border: 0;
    resize: none;
  }

`;


export const Label = styled.label`
  display: flex;
  align-items: center;
  position: absolute;
  width: 88%;
  top: 2.5%;
  left: 8%;
  font-weight: 700;
  color: #326CF9;
  letter-spacing: -1px;
  ${media.pcLarge`
    font-size: 30px;
  `}

  ${media.tabletLarge`
    font-size: 30px;
  `}

  ${media.tabletSmall`
    font-size: 30px;
  `}

  ${media.mobileLarge`
    font-size: 22px;
  `}

  ${media.mobileMid`
    font-size: 20px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  background: #fff url(${off}) center center no-repeat;

  &:checked {
    background-image: url(${on});
  }

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 16px;
    height: 16px;
  `}

  margin-right: 2%;
`;